import React from 'react';

import { CustomSelect } from '../CustomElements';

const TIME_IN_FORCE_OPTIONS = [
  { value: 'DAY', label: 'DAY' },
  { value: 'GTC', label: 'GTC' },
];

interface OrderExecutionOptionsFieldsProps {
  timeInForce: 'DAY' | 'GTC';
  outsideRegularHours: boolean;
  orderType: string;
  onTimeInForceChange: (value: 'DAY' | 'GTC') => void;
  onOutsideRegularHoursChange: (value: boolean) => void;
}

const OrderExecutionOptionsFields: React.FC<OrderExecutionOptionsFieldsProps> = ({
  timeInForce,
  outsideRegularHours,
  orderType,
  onTimeInForceChange,
  onOutsideRegularHoursChange,
}) => {
  const outsideRegularHoursDisabled = orderType === 'MARKET' || orderType === 'MIDPRICE';

  return (
    <div className="flex gap-3 items-end">
      <div className="flex-1">
        <label className="block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70">
          TIF
        </label>
        <CustomSelect
          value={timeInForce}
          onChange={(value) => onTimeInForceChange(value as 'DAY' | 'GTC')}
          options={TIME_IN_FORCE_OPTIONS}
          ariaLabel="Time in force"
        />
      </div>
      <label className={`flex flex-2 h-9 rounded-lg border px-3 items-center justify-between gap-3 transition ${outsideRegularHoursDisabled ? 'border-white/5 bg-white/2 opacity-40' : 'border-white/10 bg-white/3 hover:bg-white/5'}`}>
        <span className="text-[10px] font-bold text-muted uppercase tracking-wider leading-none">
          Outside RTH
        </span>
        <input
          type="checkbox"
          checked={outsideRegularHours}
          disabled={outsideRegularHoursDisabled}
          onChange={(event) => onOutsideRegularHoursChange(event.target.checked)}
          className="h-4 w-4 shrink-0 accent-emerald-400"
        />
      </label>
    </div>
  );
};

export default OrderExecutionOptionsFields;
